import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';

export const getTimeSlot = (brandId) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand-time-slot/' + brandId, // for android use
    headers: getHeaders(),
  });
};


export const addTimeSlot = (data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand-time-slot/',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};


export const updateTimeSlot = (data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/brand-time-slot/',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

 